import { yupBoolean, yupObject, yupPeriodicValue, yupString } from '../../yup';

/**
 * ERHL-specific additional income validation schema.
 * When isRetired is true, the short-term employment change question is skipped.
 * @param isRetired - Whether the applicant's primary income source is Retired
 */
export const erhlAdditionalIncomeSchema = (isRetired: boolean) =>
  yupObject({
    shortTermChange: isRetired ? yupBoolean().optional() : yupBoolean().required().label('This question'),
    shortTermEmploymentChange: yupString()
      .when('shortTermChange', {
        is: (val: boolean) => !isRetired && val === true,
        then: (schema) => schema.required(),
      })
      .label('Future employment details'),
    additionalIncome: isRetired ? yupBoolean().optional() : yupBoolean().required().label('This question'),
    centrelinkPayments: yupPeriodicValue().label('Centrelink payments'),
    childSupportMaintenance: yupPeriodicValue().label('Child support maintenance'),
    familyAllowance: yupPeriodicValue().label('Family allowance'),
    familyTaxBenefit: yupPeriodicValue().label('Family tax benefit'),
    governmentPension: yupPeriodicValue().label('Government pension'),
    dividendsInvestments: yupPeriodicValue().label('Dividends and investments'),
    superannuation: yupPeriodicValue().label('Superannuation'),
    other: yupPeriodicValue().label('Other'),
  });
